export default "__VITE_ASSET__c1752dbf__"